import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable react/prop-types */

import React from 'react';
import { gridSize, math } from '@atlaskit/theme';
/* eslint-disable react/no-unused-prop-types */
import { getLoadingStyle } from './utils';

var getAlignment = function getAlignment(p) {
  return p.followsIcon ? 'baseline' : 'center';
};
var gridSizeDiv2 = math.divide(gridSize, 2);
var getMargin = function getMargin(p) {
  return p.spacing === 'none' ? 0 : '0 ' + gridSizeDiv2(p) + 'px';
};

var ButtonContent = function ButtonContent(props) {
  var style = _extends({
    alignItems: getAlignment(props),
    alignSelf: getAlignment(props),
    flex: '1 1 auto',
    margin: getMargin(props),
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, getLoadingStyle(props));
  return React.createElement(
    'span',
    { style: style },
    props.children
  );
};

export default ButtonContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/modal-dialog/node_modules/@atlaskit/button/dist/esm/styled/ButtonContent.js
// module id = 814
// module chunks = 0